import ChangesIcon from "@atlaskit/icon/core/changes";
import CopyIcon from "@atlaskit/icon/core/copy";
import CrossIcon from "@atlaskit/icon/core/cross";
// import DeleteIcon from "@atlaskit/icon/core/delete";
import UploadIcon from "@atlaskit/icon/core/upload";
import RefreshIcon from "@atlaskit/icon/core/refresh";
import {token} from "@atlaskit/tokens";

export function TableSelectionBar({
    selectedCount,
    totalCount,
    onClear,
    onCopy,
    onExport,
    onReinvite,
    // onDelete,
    onRestore,
    onTransfer,
    isTransferDisabled,
    isReinviteDisabled,
    // isDeleteDisabled,
    isRestoreDisabled,
    showCopy = true,
    bulkActionMode = "delete",
}: {
    selectedCount: number
    totalCount: number
    onClear: () => void
    onCopy?: () => void
    onExport?: () => void
    onReinvite?: () => void
    onDelete?: () => void
    onRestore?: () => void
    onTransfer?: () => void
    isTransferDisabled?: boolean
    isReinviteDisabled?: boolean
    isDeleteDisabled?: boolean
    isRestoreDisabled?: boolean
    showCopy?: boolean
    bulkActionMode?: "delete" | "none" | "reinvite" | "restore"
}) {
    return (
        <div
            className="mb-2"
            style={{
                display: "grid",
                gridAutoFlow: "column",
                justifyContent: "start",
                alignItems: "center",
                gap: "12px",
                padding: "8px 12px",
                borderRadius: "4px",
                border: `1px solid ${token("color.border")}`,
                background: token("color.background.neutral"),
            }}
        >
            <button type="button" onClick={onClear} title="Clear selection" style={{color: token("color.icon.subtle")}}>
                <CrossIcon label="" />
            </button>
            <span
                style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: token("color.text"),
                }}
            >
                {selectedCount}/{totalCount} selected
            </span>
            <div
                style={{
                    display: "grid",
                    gridAutoFlow: "column",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "12px",
                }}
            >
                {showCopy === true && onCopy !== undefined ? (
                    <button type="button" onClick={onCopy} title="Copy selected rows" style={{color: token("color.icon.subtle")}}>
                        <CopyIcon label="" />
                    </button>
                ) : null}
                {onTransfer !== undefined ? (
                    <button
                        type="button"
                        onClick={onTransfer}
                        disabled={isTransferDisabled}
                        title="Transfer selected rows"
                        style={{
                            color: isTransferDisabled === true ? token("color.icon.disabled") : token("color.icon.subtle"),
                            opacity: isTransferDisabled === true ? 0.5 : 1,
                        }}
                    >
                        <ChangesIcon
                            label=""
                            color={isTransferDisabled === true ? token("color.icon.disabled") : token("color.icon.subtle")}
                        />
                    </button>
                ) : null}
                {onExport !== undefined ? (
                    <button type="button" onClick={onExport} title="Export selected rows" style={{color: token("color.icon.subtle")}}>
                        <UploadIcon label="" />
                    </button>
                ) : null}
                {bulkActionMode === "reinvite" && onReinvite !== undefined ? (
                    <button
                        type="button"
                        onClick={onReinvite}
                        disabled={isReinviteDisabled}
                        title="Bulk reinvite selected rows"
                        style={{
                            color: token("color.icon.subtle"),
                            opacity: isReinviteDisabled === true ? 0.5 : 1,
                        }}
                    >
                        <RefreshIcon label="" />
                    </button>
                ) : bulkActionMode === "restore" && onRestore !== undefined ? (
                    <button
                        type="button"
                        onClick={onRestore}
                        disabled={isRestoreDisabled}
                        title="Restore selected rows"
                        style={{
                            color: token("color.icon.subtle"),
                            opacity: isRestoreDisabled === true ? 0.5 : 1,
                        }}
                    >
                        <RefreshIcon label="" />
                    </button>
                ) : null}
                {/* Delete option temporarily commented out
                {bulkActionMode !== "none" &&
                bulkActionMode !== "reinvite" &&
                bulkActionMode !== "restore" &&
                onDelete !== undefined ? (
                    <button
                        type="button"
                        onClick={onDelete}
                        disabled={isDeleteDisabled}
                        title="Delete selected rows"
                        style={{
                            color: token("color.icon.subtle"),
                            opacity: isDeleteDisabled === true ? 0.5 : 1,
                        }}
                    >
                        <DeleteIcon label="" />
                    </button>
                ) : null}
                */}
            </div>
        </div>
    );
}
